import { Turbo } from '@hotwired/turbo-rails';

export default class TurboInit {
  // Enables Turbo Drive globally as part of the migration off rails-ujs (#35411).
  //
  // Pages that have not been migrated yet opt out with data-turbo="false" on the
  // <body> in the site layouts, so they keep their existing rails-ujs
  // behaviour until they are converted one at a time. The site subapp has no
  // data-confirm usages, so (unlike app/admin) no confirm dialog is wired here.
  static ready(turbo = Turbo) {
    turbo.session.drive = true;
  }
}
